import React, {useState} from 'react';
import {Input, Tooltip} from 'antd';
import {CloseOutlined} from '@ant-design/icons';

const TooltipInput = ({
                          value,
                          onChange,
                          automationTooltips,
                          placeholder,
                          className,
                          name,
                          id
                      }) => {
    const [tooltipState, setTooltipState] = useState({
        visible: false,
        currentTooltip: null,
        matchedWord: ''
    });
    const [closedTooltips, setClosedTooltips] = useState(new Set());

    const handleInputChange = (e) => {
        const newValue = e.target.value;
        onChange(e);

        const inputLower = newValue.toLowerCase();

        for (const tooltip of automationTooltips) {
            // Skip if this tooltip was previously closed
            if (closedTooltips.has(tooltip.keyword)) {
                continue;
            }

            const keywordLower = tooltip.keyword.toLowerCase();

            if (inputLower.includes(keywordLower)) {
                const keywordIndex = inputLower.indexOf(keywordLower);
                const beforeChar = keywordIndex > 0 ? inputLower[keywordIndex - 1] : ' ';
                const afterChar = keywordIndex + keywordLower.length < inputLower.length ?
                    inputLower[keywordIndex + keywordLower.length] : ' ';

                if ([' ', '\n', '\t', undefined].includes(beforeChar) &&
                    [' ', '\n', '\t', undefined].includes(afterChar)) {
                    // Only show if it wasn't previously closed
                    if (!closedTooltips.has(tooltip.keyword)) {
                        setTooltipState({
                            visible: true,
                            currentTooltip: tooltip,
                            matchedWord: tooltip.keyword
                        });
                        return;
                    }
                }
            }
        }

        setTooltipState(prev => ({...prev, visible: false}));
    };

    let closeTimeout = null;

    const handleClose = () => {
        if (tooltipState.currentTooltip) {
            // Add the keyword to closedTooltips when user closes the tooltip
            setClosedTooltips(prev => new Set([...prev, tooltipState.currentTooltip.keyword]));
            setTooltipState(prev => ({...prev, visible: false}));
        }
    };

    const handleCloseMouseDown = () => {
        closeTimeout = setTimeout(() => {
            // Handle long press - could add different behavior here if needed
            handleClose();
        }, 500);
    };

    const handleCloseMouseUp = () => {
        if (closeTimeout) {
            clearTimeout(closeTimeout);
            handleClose();
        }
    };

    const tooltipContent = tooltipState.currentTooltip && (
        <div className="max-w-xs bg-white text-dark p-4 m-[1px]">
            <div className="flex justify-end items-center mb-2">
                <CloseOutlined
                    className="cursor-pointer hover:text-gray-600"
                    onMouseDown={handleCloseMouseDown}
                    onMouseUp={handleCloseMouseUp}
                    onMouseLeave={() => {
                        if (closeTimeout) {
                            clearTimeout(closeTimeout);
                        }
                    }}
                />
            </div>
            <div className="mb-2 text-base">
                {tooltipState.currentTooltip.tooltip_text}
            </div>
            <a
                href="#"
                className="text-blue-500 hover:text-blue-700 text-base"
                onClick={(e) => {
                    e.preventDefault();
                    window.open('/data-source', '_blank');
                }}
            >
                Check the automation
            </a>
        </div>
    );

    return (
        <Tooltip
            open={tooltipState.visible}
            title={tooltipContent}
            placement="bottom"
            trigger="click"
            overlayClassName="max-w-sm"
            color={"#5b7df7"}
            overlayInnerStyle={{
                padding: 1,
            }}
        >
            <Input
                value={value}
                onChange={handleInputChange}
                placeholder={placeholder}
                className={className}
                name={name}
                id={id}
            />
        </Tooltip>
    );
};

export default TooltipInput;
